var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { TypeActionRanking } from "./actionRanking";
var initial = {
    coopXpHighScores: {
        currentPosition: undefined,
        highScores: [],
        selfScore: undefined,
    },
    playerXpHighScores: {
        currentPosition: undefined,
        highScores: [],
        selfScore: undefined,
    },
    selectedLanguage: undefined,
};
export var reducerPlayerRank = function (state, action) {
    if (state === void 0) { state = initial; }
    switch (action.type) {
        case TypeActionRanking.LanguageFilterSelected:
            return __assign({}, state, { selectedLanguage: action.selectedLanguage });
        case TypeActionRanking.PlayerXpSelfScoreReceived:
            return __assign({}, state, { playerXpHighScores: __assign({}, state.playerXpHighScores, { selfScore: action.selfScore }) });
        case TypeActionRanking.PlayerXpHighSocresReceived:
            var playerXpcurrentPosition = action.highScores && action.highScores.length > 0
                ? action.highScores[0].position
                : undefined;
            return __assign({}, state, { playerXpHighScores: __assign({}, state.playerXpHighScores, { currentPosition: playerXpcurrentPosition, highScores: action.highScores }) });
        case TypeActionRanking.ClearPlayerXpHighScores:
            return __assign({}, state, { playerXpHighScores: __assign({}, state.playerXpHighScores, { highScores: [] }) });
        case TypeActionRanking.CoopXpSelfScoreReceived:
            return __assign({}, state, { coopXpHighScores: __assign({}, state.coopXpHighScores, { selfScore: action.selfScore }) });
        case TypeActionRanking.CoopXpHighSocresReceived:
            var coopXpCurrentPosition = action.highScores && action.highScores.length > 0
                ? action.highScores[0].position
                : undefined;
            return __assign({}, state, { coopXpHighScores: __assign({}, state.coopXpHighScores, { currentPosition: coopXpCurrentPosition, highScores: action.highScores }) });
        case TypeActionRanking.ClearCoopXpHighScores:
            return __assign({}, state, { coopXpHighScores: __assign({}, state.coopXpHighScores, { highScores: [] }) });
        default:
            return state;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/features/ranking/reducerPlayerRank.ts
// module id = 2974
// module chunks = 3